import {
  api_get_email_config_list_url,
  api_create_email_config_url,
  api_update_email_config_url,
  api_activate_deactivate_email_config_url,
  api_get_email_config_details_url
} from "./smtpApi";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  parser_get_email_config_list,
  parser_create_email_config,
  parser_update_email_config,
  parser_activate_deactivate_email_config,
  parser_get_email_config_details
} from "./smtpParser";
import { PAGE } from "../../helpers/constants";

export const get_email_config_list = createAsyncThunk(
  "get_email_config_list",
  async (payload) => {
    try {
      const { page, limit, qn, qs } = payload
      const response = await api_get_email_config_list_url(page, limit, qn, qs);
      const data = parser_get_email_config_list(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);


export const create_email_config = createAsyncThunk(
  "create_company",
  async (payload) => {
    try {
      const { mail_username, mail_password, mail_port, mail_server, mail_form_name, mail_cc, company_id, process_id } = payload;
      const formData = new FormData();
      if (mail_username) formData.append("mail_username", mail_username);
      if (mail_password) formData.append("mail_password", mail_password);
      if (mail_port) formData.append("mail_port", mail_port);
      if (mail_server) formData.append("mail_server", mail_server);
      if (mail_form_name) formData.append("mail_form_name", mail_form_name);
      if (mail_cc) formData.append("mail_cc", mail_cc);
      if (company_id) formData.append("company_id", company_id);
      if (process_id) formData.append("process_id", process_id);

      const response = await api_create_email_config_url(formData);
      const data = parser_create_email_config(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const update_email_config = createAsyncThunk(
  "update_process",
  async (payload) => {
    try {
      const { updated_data, config_id } = payload
      const formData = new FormData();
      if (updated_data.mail_username) formData.append("mail_username", updated_data.mail_username);
      if (updated_data.mail_password) formData.append("mail_password", updated_data.mail_password);
      if (updated_data.mail_port) formData.append("mail_port", updated_data.mail_port);
      if (updated_data.mail_server) formData.append("mail_server", updated_data.mail_server);
      if (updated_data.mail_form_name) formData.append("mail_form_name", updated_data.mail_form_name);
      if (updated_data.mail_cc) formData.append("mail_cc", updated_data.mail_cc);
      if (updated_data.company_id) formData.append("company_id", updated_data.company_id);
      if (updated_data.process_id) formData.append("process_id", updated_data.process_id);
      const response = await api_update_email_config_url(config_id, formData);
      const data = parser_update_email_config(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);


export const activate_deactivate_email_config = createAsyncThunk(
  "activate_deactivate_email_config",
  async (payload) => {
    try {
      const { config_id, updated_data } = payload
      const response = await api_activate_deactivate_email_config_url(config_id, updated_data)
      const data = parser_activate_deactivate_email_config(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const get_email_config_details = createAsyncThunk(
  "get_email_config_details",
  async (payload) => {
    try {
      const response = await api_get_email_config_details_url(payload);
      const data = parser_get_email_config_details(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

const initialState = {
  common_loading: false,
  is_email_config_modal_open: false,
  selected_status: '',
  search_query: '',
  selected_data: null,
  c_action: null,
  config_id: null,
  config_list: [],
  total_email_config_count: 0,
  active_email_config: 0,
  page: PAGE - 1
};

export const smtpSlice = createSlice({
  name: "email_config",
  initialState,
  reducers: {
    setConfigPage: (state, action) => {
      state.page = action.payload;
    },
    setConfigModalOpen: (state, action) => {
      state.is_email_config_modal_open = action.payload;
    },
    setAction: (state, action) => {
      state.c_action = action.payload;
    },
    setId: (state, action) => {
      state.config_id = action.payload;
    },
    setStatus: (state, action) => {
      state.selected_status = action.payload ? action.payload : '';
    },
    setSearchQuery: (state, action) => {
      state.search_query = action.payload;
    }
  },
  extraReducers: (builder) => {
    // get email_config list
    builder.addCase(get_email_config_list.pending, (state) => {
      state.common_loading = true;
    })
    builder.addCase(get_email_config_list.fulfilled, (state, action) => {
      state.common_loading = false;
      state.config_list = action.payload.data.email_config;
      state.total_email_config_count = action.payload.data.total_count;
      state.active_email_config = action.payload.data.email_config.filter(email_config => email_config.is_active === true).length;
    })
    builder.addCase(get_email_config_list.rejected, (state) => {
      state.common_loading = false;
    })
    //create email_config
    builder.addCase(create_email_config.pending, (state) => {
      state.common_loading = true;
    })
    builder.addCase(create_email_config.fulfilled, (state, action) => {
      state.common_loading = false;
      state.config_list.push(action.payload.data)
    })
    builder.addCase(create_email_config.rejected, (state) => {
      state.common_loading = false;
    })
    //update email_config
    builder.addCase(update_email_config.pending, (state) => {
      state.common_loading = true;
    })
    builder.addCase(update_email_config.fulfilled, (state, action) => {
      state.common_loading = false;
      state.config_list = state.config_list.map((email_config) =>
        email_config.id === action.payload.data.id ? { ...email_config, ...action.payload.data } : email_config
      );
    })
    builder.addCase(update_email_config.rejected, (state) => {
      state.common_loading = false;
    })
    // activate_deactivate_email_config
    builder.addCase(activate_deactivate_email_config.pending, (state) => {
      state.common_loading = true;
    });
    builder.addCase(activate_deactivate_email_config.fulfilled, (state, action) => {
      state.common_loading = false;
      state.config_list = state.config_list.map((email_config) =>
        email_config.id === action.payload.data.id ? { ...email_config, ...action.payload.data } : email_config
      );
    });
    builder.addCase(activate_deactivate_email_config.rejected, (state) => {
      state.common_loading = false;
    })
    //get email_config details
    builder.addCase(get_email_config_details.pending, (state) => {
      state.common_loading = true;
    })
    builder.addCase(get_email_config_details.fulfilled, (state, action) => {
      state.common_loading = false;
      state.selected_data = action.payload.data
    })
    builder.addCase(get_email_config_details.rejected, (state) => {
      state.common_loading = false;
    })
  },
});

// Action creators are generated for each case reducer function
export const {
  setConfigModalOpen,
  setConfigPage,
  setAction,
  setId,
  setStatus,
  setSearchQuery
} = smtpSlice.actions;
export default smtpSlice.reducer;                            
